import createGlobalState from "@ui/lib/createGlobalState";
import { MeasuresChartType } from "../MeasuresChartType";

export const useMeasureChartType = createGlobalState({
  storage: "session",
  key: "measureChartType",
  type: MeasuresChartType,
  scoped: true,
});
